import _ from "lodash";
import React, { createRef, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import {
  getAnyTotalReportClear,
  getProfileCompletionReport,
  getProfileCompletionReportClear,
} from "../../../redux/reports/actions";
import NextArrow from "../../LearningPaths/NextArrow";
import PrevArrow from "../../LearningPaths/PrevArrow";
import Pagination from "../../../pages/Orders/Pagination";
import exportFromJSON from "export-from-json";
import StaticUtils from "../../../utils/StaticUtils";
import * as XLSX from "xlsx";
import PieChart from "../../Layouts/Graphs/PieChart";
import ReportGraphSection from "../ReportGraphSection";
import { formatMinutes, SessionKeys } from "../../../utils/AppUtils";
import PaginationProgress from "./PaginationProgress";
import moment from "moment";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { CheckBox } from "@mui/icons-material";
import axios from "axios";
import CONFIG from "../../../utils/config";
import ConfirmModal from "../../modal/ConfirmModal";
import SimplePopup from "../../modal/SimplePopup";
import API_LIST from "../../../utils/apiList";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import { useTranslation } from "react-i18next";
const fileName = "CourseProgress";
const exportType = "xls";
// let PageSize = 20;
const sliderRef = createRef();
const settings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  dots: true,
  arrows: true,
  autoplaySpeed: 2000,
  infinite: false,
  centerMode: false,
  swipe: false,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
const ProgressReportTableComponent = (props) => {
  const {
    getFilteredData,
    setIsLoading,
    isLoading,
    isView,
    statusFilterData,
    type,
    canShow,
    setCanShow,
    profileReports,
    message,
    isCompliance,
    searchTable,
    contentHeading,
    fromPage,
    reportType,
    isMobile,
    pageNum,
    setPageNum,
    progressSort,
    setProgressSort,
    searchInput,
    setSearchInput,
    fetchData,
    pageSize,
    setPageSize,
    // currentTableData,
    //currentPage,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const profileReportRes = useSelector((state) => state.report.profileReport);
  const anyTotalReportRes = useSelector((state) => state.report.anyTotalReport);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const authIframeBroker = useSelector((state) => state.auth.authIframeBroker);
  // const [profileReports, setProfileReports] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [legends, setLegends] = useState([]);
  const [series, setSeries] = useState([]);
  const [statusSort, setStatusSort] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [officeLabel, setOfficeLabel] = useState("");

  const [isAllPageSelectedCheck, setIsAllPageSelectedCheck] = useState(false);
  const [allSelectedCount, setAllSelectedCount] = useState(0);

  const [allTableList, setAllTableList] = useState([]);
  const [isHaveCompleted, setIsHaveCompleted] = useState(false);
  const [disableFooter, setDisableFooter] = useState(true);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (
        !_.isEmpty(authBroker.payload?.user?.config) &&
        authBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel("Office Name");
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      // alert(JSON.stringify(authIframeBroker.payload.user.config))
      if (
        !_.isEmpty(authIframeBroker.payload?.user?.config) &&
        authIframeBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authIframeBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel("Office Name");
      }
    }
  }, [authIframeBroker]);

  useEffect(() => {
    if (pageNum) {
      setCurrentPage(pageNum);
    }
  }, [pageNum]);

  useEffect(() => {
    if (!searchInput) {
      setSearchTerm("");
    }
  }, [searchInput]);

  const currentTableData = useMemo(() => {
    if (!_.isEmpty(profileReports)) {
      console.log("tableData : ", profileReports?.user_data);

      const reportsData = _.cloneDeep(profileReports?.user_data);
      reportsData.map((i) => {
        let final = new Array();
        let temp = [];
        if (!_.isEmpty(i.lp_details)) {
          i.lp_details.map((j, index) => {
            if (j?.is_level && j?.start_level && j?.end_level) {
              final.push(j);
            } else if (
              j?.is_level &&
              (j?.start_level || j?.in_level || j?.end_level)
            ) {
              temp.push(j);
              if (j?.end_level) {
                final.push(temp);
                temp = [];
              }
            } else {
              final.push(j);
            }
          });
          i["lp_details"] = final;
        }
      });

      // let reportsData = _.clone(profileReports.user_data);
      // reportsData = _.sortBy(reportsData, 'profile_status');
      // if (statusSort === "desc") {
      //   reportsData = _.reverse(reportsData);
      // }
      // reportsData = _.sortBy(reportsData, (o) => Number(o.profile_progress));
      // console.log("test asc", reportsData);
      // if (progressSort === "desc") {
      //   reportsData = _.reverse(reportsData);
      //   console.log("test desc", reportsData);
      // }
      // console.log("test asc1", reportsData);
      // const firstPageIndex = (currentPage - 1) * pageSize;
      // const lastPageIndex = firstPageIndex + pageSize;
      // //setCanShow(true);
      // let tableData = reportsData?.slice(firstPageIndex, lastPageIndex);
      console.log("tableData: ", reportsData);
      setAllTableList(reportsData);
      for (let i = 0; i < reportsData.length; i++) {
        if (
          reportsData[i].status === "completed" ||
          reportsData[i].profile_status === "completed"
        ) {
          setIsHaveCompleted(true);
          break;
        } else {
          setIsHaveCompleted(false);
        }
      }
      console.log("PG NUMBER REPORTTYPE", reportType);
      if (reportType === "learningpath") {
        // console.log('PG NUMBER', reportsData[0]?.is_detail_loading)
        if (Array.isArray(reportsData) && !reportsData[0]?.is_detail_loading) {
          setDisableFooter(false);
        }
      } else {
        setDisableFooter(false);
      }
      return reportsData;
    }
    // }, [currentPage, profileReports, statusSort, progressSort, pageNum]);
  }, [profileReports]);

  console.log("profile reports", profileReports, canShow, currentTableData);

  // useEffect(() => {
  //   if (!_.isEmpty(profileReports)) {
  //     profileReports.map((i) => {
  //       let final = new Array();
  //       let temp = [];
  //       if (!_.isEmpty(i.lp_details)) {
  //         i.lp_details.map((j, index) => {
  //           if ( j?.is_level && j?.start_level && j?.end_level) {
  //             final.push(j);
  //           }
  //           else if ( j?.is_level && ((j?.start_level) || (j?.in_level)|| (j?.end_level))) {
  //             temp.push(j);
  //             if ( j?.end_level) {
  //               final.push(temp);
  //               temp = [];
  //             }
  //           } else {
  //             final.push(j);
  //           }
  //         });
  //         i["lp_details"] = final;
  //       }
  //     });
  //   }
  //   console.log("final",profileReports)

  // }, [profileReports])

  console.log("filtered_data", profileReports);

  const ExportToExcel = () => {
    const data = _.cloneDeep(profileReports);
    for (let item of data) {
      item.profile_status =
        item?.profile_status === "in-progress" ||
        item?.profile_status === "Inprogress"
          ? "In Progress"
          : item?.profile_status === "Yet to start" ||
            item?.profile_status === "not-started"
          ? "Yet to start"
          : item?.profile_status === "OverDue"
          ? "Overdue"
          : "Completed";
      item.profile_progress =
        item?.profile_progress !== undefined && item?.profile_progress !== ""
          ? item?.profile_progress + "%"
          : "-";
      item.complete_date =
        item?.complete_date !== undefined && item?.complete_date !== ""
          ? moment(
              StaticUtils.getDateFromTimeStamp(item?.complete_date),
              "MM/DD/YYYY"
            ).format("DD MMM, YYYY")
          : "-";
    }

    //for sequencing
    let tempArr = [];
    for (const item of data) {
      let obj = {
        first_name: item.first_name,
        last_name: item.last_name,
        email: item.email,
        office_name: item.office_name,
        course_name: item.course_name,
        profile_status: item.profile_status,
        profile_progress: item.profile_progress,
        complete_date: item.complete_date,
      };
      tempArr.push(obj);
    }

    const newThing = [];
    tempArr.map((item) => {
      newThing.push(
        _.mapKeys(item, (value, key) => {
          switch (key) {
            case "first_name":
              return "First Name";
            case "last_name":
              return "Last Name";
            case "email":
              return "Email";
            case "office_name":
              return "Office Name";
            case "course_name":
              return "Course Name";
            case "profile_status":
              return "Status";
            case "profile_progress":
              return "% Completed";
            case "complete_date":
              return "Date of Completion";
            default:
              return;
          }
        })
      );
    });

    for (let i = 0; i < newThing.length; i++) {
      // arrayObj[i].stroke = arrayObj[i]['key1'];
      delete newThing[i].undefined;
    }

    for (let i = 0; i < data.length; i++) {
      // arrayObj[i].stroke = arrayObj[i]['key1'];
      delete data[i]._id;
    }
    // console.log('data:', data)
    // exportFromJSON({ data, fileName, exportType })

    //For mobile
    let tempObj = {
      method: isCompliance ? "ComplianceReport" : "LearningProgressReport",
      report: newThing,
    };
    if (window.callbackHandler != undefined) {
      window.callbackHandler.postMessage(JSON.stringify(tempObj));
    } else if (window.webkit != undefined) {
      if (window.webkit.messageHandlers.callbackHandler != undefined) {
        window.webkit.messageHandlers.callbackHandler.postMessage(
          JSON.stringify(tempObj)
        );
      }
    }

    const worksheet = XLSX.utils.json_to_sheet(newThing);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    let fileNameNew = isCompliance
      ? "ComplianceReport"
      : "LearningProgressReport";
    XLSX.writeFile(workbook, fileNameNew + ".xlsx");
  };
  const Link = ({ id, title }) => {
    console.log("LINK TOUR", id, title);
    return (
      <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
        <span className="full-bar"></span>
      </OverlayTrigger>
    );
  };

  const [selectedRemindUsers, setSelectedRemindUser] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectionPerPage, setSelectionPerPage] = useState(new Map());
  const [isAnyOneSelected, setIsAnyOneSelected] = useState(false);

  useEffect(() => {
    let tempMap = _.cloneDeep(selectionPerPage);
    let pageNumber = pageNum === 0 ? 1 : pageNum;
    let finalTemp = tempMap.set(pageNumber, selectedRemindUsers);
    setSelectionPerPage(finalTemp);
    console.log("selectedPerPage2: ", finalTemp, currentPage);
    let checkIsAllSelected = checkAllPagesSelected(finalTemp);
    setIsAllPageSelectedCheck(checkIsAllSelected);
  }, [selectedRemindUsers]);

  const allPageSelectFunc = () => {
    let pages = 0;
    if (allTableList.length % pageSize === 0) {
      pages = allTableList.length / pageSize;
    } else {
      pages = allTableList.length / pageSize + 1;
    }

    let tempMap = new Map();
    for (let i = 0; i < pages; i++) {
      const firstPageIndex = (i - 1) * pageSize;
      const lastPageIndex = firstPageIndex + pageSize;
      let tableData = allTableList?.slice(firstPageIndex, lastPageIndex);

      let selectedUsers = clickAllSelectedUser(tableData, true);
      if (i === currentPage) {
        setSelectedRemindUser(selectedUsers);
      }
      tempMap.set(i, selectedUsers);
    }
    setSelectionPerPage(tempMap);
  };

  const checkAllPagesSelected = (selectionPerPage) => {
    let selectedCount = 0;
    for (let [key, value] of selectionPerPage) {
      selectedCount = selectedCount + value.length;
    }

    let itemCounts = 0;
    for (let i = 0; i < allTableList.length; i++) {
      const item = allTableList[i];
      if (item?.status?.toLowerCase() !== "completed") {
        itemCounts++;
      }
    }

    setAllSelectedCount(selectedCount);
    console.log("sleeccted: ", selectedCount, itemCounts);

    if (selectedCount === 0 && itemCounts === 0) {
      return false;
    } else {
      return selectedCount === itemCounts;
    }
  };

  useEffect(() => {
    let currSelection = selectionPerPage.get(pageNum);
    console.log("selectedPerPage1: ", selectionPerPage, pageNum);
    if (currSelection === undefined) {
      setSelectedRemindUser([]);
      setIsAllSelected(false);
    } else {
      setSelectedRemindUser(currSelection);
      if (currSelection.length === currentTableData.length) {
        setIsAllSelected(true);
      } else {
        setIsAllSelected(false);
      }
    }
  }, [pageNum]);

  // useEffect(() => {
  //   if (!_.isEmpty(currentTableData)) {
  //     // alert(JSON.stringify(currentTableData))
  //     let isAllSelected = false;
  //     for (let user of selectedRemindUsers) {
  //       for (let data of currentTableData) {
  //         if (_.toNumber(user.user_id) == _.toNumber(data.uid)
  //           && user.entity_id == data.lp_id) {
  //             isAllSelected = true;
  //         } else {
  //           isAllSelected = false;
  //         }
  //       }
  //     }
  //     setIsAllSelected(isAllSelected)
  //   }
  // }, [currentTableData])

  useEffect(() => {
    checkIfAnyOneSelected();
  }, [selectionPerPage]);

  const checkIfAnyOneSelected = () => {
    let isSelected = false;
    if (selectionPerPage) {
      let tempMap = _.cloneDeep(selectionPerPage);
      for (let [key, value] of tempMap) {
        console.log(key + " is " + value);
        if (value.length > 0) {
          isSelected = true;
          break;
        }
      }
    }
    setIsAnyOneSelected(isSelected);
  };

  const clickAllSelectedUser = () => {
    if (isAllSelected) {
      setSelectedRemindUser([]);
      setIsAllSelected(false);
    } else {
      let selectedArr = [];
      for (let index = 0; index < currentTableData.length; index++) {
        const item = currentTableData[index];
        if (
          item.status === "completed" ||
          item.profile_status === "completed"
        ) {
          continue;
        }
        let obj = {
          user_id: reportType === "learningpath" ? item.uid : item.user_id,
          entity_id:
            reportType === "learningpath" ? item.lp_id : item.course_id,
          entity_type:
            fromPage === 1
              ? "Course"
              : fromPage === 2
              ? "learning-path"
              : fromPage === 3
              ? "onboarding-learning-path"
              : "Video",
          status:
            reportType === "learningpath" ? item.status : item.profile_status,
          uniq_id:
            reportType === "learningpath"
              ? item.uid + item.lp_id
              : item.user_id + item.course_id,
        };
        selectedArr.push(obj);
      }
      setSelectedRemindUser(selectedArr);
      setIsAllSelected(true);
    }
  };

  const addRemindSelectedUser = (item, isRemove) => {
    if (item.status === "completed" || item.profile_status === "completed") {
      return;
    }
    console.log("inner:::::");
    if (isRemove) {
      let filteredArr = [];
      for (let i = 0; i < selectedRemindUsers.length; i++) {
        const element = selectedRemindUsers[i];
        if (reportType === "learningpath") {
          if (element.uniq_id !== item.uid + item.lp_id) {
            filteredArr.push(element);
          }
        } else {
          if (element.uniq_id !== item.user_id + item.course_id) {
            filteredArr.push(element);
          }
        }
      }
      setSelectedRemindUser(filteredArr);
      if (filteredArr.length < currentTableData.length) {
        setIsAllSelected(false);
      }
    } else {
      let obj = {
        user_id: reportType === "learningpath" ? item.uid : item.user_id,
        entity_id: reportType === "learningpath" ? item.lp_id : item.course_id,
        entity_type:
          fromPage === 1
            ? "Course"
            : fromPage === 2
            ? "learning-path"
            : fromPage === 3
            ? "onboarding-learning-path"
            : "Video",
        status:
          reportType === "learningpath" ? item.status : item.profile_status,
        uniq_id:
          reportType === "learningpath"
            ? item.uid + item.lp_id
            : item.user_id + item.course_id,
      };
      let selectedArr = _.cloneDeep(selectedRemindUsers);
      selectedArr.push(obj);
      setSelectedRemindUser(selectedArr);
      if (selectedArr.length === currentTableData.length) {
        setIsAllSelected(true);
      }
    }
  };
  const isExistId = (item) => {
    let isExist = false;
    console.log("isExist: ", selectedRemindUsers);
    for (let i = 0; i < selectedRemindUsers.length; i++) {
      const element = selectedRemindUsers[i];
      if (reportType === "learningpath") {
        if (element.uniq_id === item.uid + item.lp_id) {
          isExist = true;
          break;
        }
      } else {
        if (element.uniq_id === item.user_id + item.course_id) {
          isExist = true;
          break;
        }
      }
    }

    return isExist;
  };
  const resetAllSelection = () => {
    setIsAllSelected(false);
    setSelectionPerPage(new Map().set(0, []));
    setSelectedRemindUser([]);
  };

  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const remindSelectedUserReq = async () => {
    let selectedValues = [];
    for (let [key, value] of selectionPerPage) {
      console.log(key + " is " + value);
      selectedValues = [...selectedValues, ...value];
    }
    // alert(JSON.stringify(selectedValues))
    // return;
    setIsLoading(true);
    await axios({
      method: "post",
      url: `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.API_ROUTES_BROKER.REMIND_USER_REPORT_REQ}`,
      data: {
        token: isMobile
          ? localStorage.getItem(SessionKeys.API_TOKEN)
          : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        userdata: selectedValues,
      },
      header: { "Content-Type": "application/json" },
    })
      .then((response) => {
        console.log("RESPONSERemind", response);
        setIsLoading(false);
        if (isMobile) {
          window.scrollTo(0, 0);
        }
        if (response.data.status) {
          setShowModalMsg(response.data.message);
          resetAllSelection();
        } else {
          setShowModalMsg("Error in sending reminder.");
        }
        let obj = { message: "scrollToTop" };
        window.parent.postMessage(obj, "*");
        window.scrollTo(0, 0);
        setConfirmModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        window.scrollTo(0, 0);
        let obj = { message: "scrollToTop" };
        window.parent.postMessage(obj, "*");
        setConfirmModal(true);
        setShowModalMsg("Error in sending reminder.");
        setIsLoading(false);
      });
  };

  const level_name = "level_name";
  const renderTableReport = () => {
    return (
      <div className="row list-coach report-table-rsp">
        <div className="col-lg-12 col-md-12">
          <div className="table-responsive1">
            <div className="tablebox">
              <table className="table mb-0 office_list table-striped">
                <thead>
                  <tr>
                    {/* <th>
                      <div
                        className="form-check cursor-pointer position-relative ps-0 pt-0"
                        onClick={() => {
                          clickAllSelectedUser();
                        }}
                      >
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          checked={isAllSelected}
                        />
                        <label
                          className="form-check-label cursor-pointer"
                          for="termofusein"
                        ></label>
                      </div>
                    </th> */}
                    <th className="office-province">{t("name")}</th>
                    {reportType === "learningpath" && (
                      <th
                        className={`office-province sortingtable cursor-pointer 
                    ${progressSort === "asc" ? "" : "decend"}`}
                        onClick={() => {
                          resetAllSelection();
                          setProgressSort(
                            progressSort === "asc" ? "desc" : "asc"
                          );
                          setPageNum(1);
                        }}
                      >
                        {t("Progress")} %
                      </th>
                    )}
                    <th className="office-province">{t("Role")}</th>
                    <th className="office-province">{t("Email")}</th>
                    <th className="office-province">{t("User Status")}</th>
                    <th className="office-province">{officeLabel}</th>
                    {/* <th className="office-province">{t("TeamManager")}</th> */}
                    {/* <th className="office-province">User Status</th> */}
                    <th className="office-province">
                      {fromPage === 1
                        ? t("Asset")
                        : fromPage === 2
                        ? t("Action Path")
                        : fromPage === 3
                        ? t("Onboarding Action Path")
                        : t("Video")}
                    </th>

                    <th className="office-province">{reportType==="learningpath"?t("Action Path ID"):t("Asset ID")}</th>
                    {reportType==="compliance" && <th className="office-province">{t("Asset Type")}</th>}
                    {reportType==="compliance" && <th className="office-province">{t("Asset Duration")}</th>}
                    <th className="office-province">{t("Completion Date & Time (ET)")}</th>
                    <th
                      className={`office-province cursor-pointer text-center `}
                      // ${statusSort === 'asc' ? '' : 'decend'}`}
                      //   onClick={() => { setStatusSort(statusSort === 'asc' ? 'desc' : 'asc') }}
                      // style={{ width: "13%" }}
                    >
                      {t("Status")}
                    </th>
                    {reportType !== "learningpath" && (
                      <th
                        className={`office-province sortingtable cursor-pointer text-center
                    ${progressSort === "asc" ? "" : "decend"}`}
                        onClick={() => {
                          resetAllSelection();
                          setProgressSort(
                            progressSort === "asc" ? "desc" : "asc"
                          );
                          setPageNum(1);
                        }}
                      >
                        {t("Progress")} %
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {currentTableData.length > 0 &&
                    currentTableData?.map((item, index) => (
                      // return (
                      <tr className="addBGcustomw">
                       
                        <td>{item?.first_name + " " + item?.last_name}</td>
                        {reportType === "learningpath" && (
                          <td className="progress-bxo">
                            <div className="d-flex align-items-center justify-content-start rogress">
                              <strong className="d-progress">
                                {item?.profile_progress !== undefined &&
                                item?.profile_progress !== ""
                                  ? item?.profile_progress + "%"
                                  : "-"}
                              </strong>
                              {reportType === "learningpath" && (
                                <span className="progess-bars-reports">
                                  {item?.is_detail_loading ? (
                                    <div className="d-flex gap-1">
                                      {[1, 2, 3].map((lp) => {
                                        return (
                                          <ShimmerScreen
                                            case="rect"
                                            width="0.4rem"
                                            height="0.2rem"
                                            borderRadius="0.1rem"
                                          />
                                        );
                                      })}
                                    </div>
                                  ) : (
                                    <>
                                      {item?.lp_details.length > 0 &&
                                        item.lp_details.map(
                                          (lp) =>
                                            // return (
                                            _.isArray(lp) ? (
                                              lp?.length > 0 ? (
                                                <>
                                                  <span className="group-dot">
                                                    <Link
                                                      title={lp[0]?.level_name}
                                                      id="t-2"
                                                    ></Link>
                                                    {lp?.length > 0 &&
                                                      lp?.map((lp1) => {
                                                        return (
                                                          console.log(
                                                            "lp1",
                                                            lp1
                                                          ),
                                                          (
                                                            <>
                                                              {_.toNumber(
                                                                lp1.progress
                                                              ) >= 100 ? (
                                                                <OverlayTrigger
                                                                  placement="bottom"
                                                                  delay={{
                                                                    show: 250,
                                                                    hide: 400,
                                                                  }}
                                                                  overlay={
                                                                    <Tooltip id="tooltip-disabled">
                                                                      {lp1.name}
                                                                    </Tooltip>
                                                                  }
                                                                >
                                                                  <span
                                                                    className={`dotted-bar complete-bar ${
                                                                      lp1.start_level ||
                                                                      lp1.end_level ||
                                                                      lp1.is_level
                                                                        ? "startp"
                                                                        : ""
                                                                    }`}
                                                                  ></span>
                                                                </OverlayTrigger>
                                                              ) : _.toNumber(
                                                                  lp1.progress
                                                                ) === 0 ||
                                                                lp1.progress ===
                                                                  null ? (
                                                                <OverlayTrigger
                                                                  placement="bottom"
                                                                  delay={{
                                                                    show: 250,
                                                                    hide: 400,
                                                                  }}
                                                                  overlay={
                                                                    <Tooltip id="tooltip-disabled">
                                                                      {lp1.name}
                                                                    </Tooltip>
                                                                  }
                                                                >
                                                                  <span
                                                                    className={`dotted-bar ${
                                                                      lp1.start_level ||
                                                                      lp1.end_level ||
                                                                      lp1.is_level
                                                                        ? "startp"
                                                                        : ""
                                                                    }`}
                                                                  ></span>
                                                                </OverlayTrigger>
                                                              ) : (
                                                                <OverlayTrigger
                                                                  placement="bottom"
                                                                  delay={{
                                                                    show: 250,
                                                                    hide: 400,
                                                                  }}
                                                                  overlay={
                                                                    <Tooltip id="tooltip-disabled">
                                                                      {lp1.name}
                                                                    </Tooltip>
                                                                  }
                                                                >
                                                                  <span
                                                                    className={`dotted-bar inprogress-bar ${
                                                                      lp1.start_level ||
                                                                      lp1.end_level ||
                                                                      lp1.is_level
                                                                        ? "startp"
                                                                        : ""
                                                                    }`}
                                                                  ></span>
                                                                </OverlayTrigger>
                                                              )}
                                                            </>
                                                          )
                                                        );
                                                      })}
                                                  </span>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <>
                                                {_.toNumber(lp.progress) >=
                                                100 ? (
                                                  <>
                                                    <span className="single-bar">
                                                      {lp.start_level ||
                                                      lp.end_level ||
                                                      lp.is_level ? (
                                                        <Link
                                                          title={
                                                            lp.level_name
                                                              ? lp.level_name
                                                              : ""
                                                          }
                                                          id={"t-single"}
                                                        ></Link>
                                                      ) : (
                                                        ""
                                                      )}

                                                      <OverlayTrigger
                                                        placement="bottom"
                                                        delay={{
                                                          show: 250,
                                                          hide: 400,
                                                        }}
                                                        overlay={
                                                          <Tooltip id="tooltip-disabled">
                                                            {lp.name}
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <span
                                                          className={`dotted-bar complete-bar ${
                                                            lp.start_level ||
                                                            lp.end_level ||
                                                            lp.is_level
                                                              ? "startp"
                                                              : ""
                                                          }`}
                                                        ></span>
                                                      </OverlayTrigger>
                                                    </span>
                                                  </>
                                                ) : _.toNumber(lp.progress) ===
                                                    0 ||
                                                  lp.progress === null ? (
                                                  <>
                                                    <span className="single-bar">
                                                      {lp.start_level ||
                                                      lp.end_level ||
                                                      lp.is_level ? (
                                                        <Link
                                                          title={
                                                            lp.level_name
                                                              ? lp.level_name
                                                              : ""
                                                          }
                                                          id={"t-single"}
                                                        ></Link>
                                                      ) : (
                                                        ""
                                                      )}
                                                      <OverlayTrigger
                                                        placement="bottom"
                                                        delay={{
                                                          show: 250,
                                                          hide: 400,
                                                        }}
                                                        overlay={
                                                          <Tooltip id="tooltip-disabled">
                                                            {lp.name}
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <span
                                                          className={`dotted-bar ${
                                                            lp.start_level ||
                                                            lp.end_level ||
                                                            lp.is_level
                                                              ? "startp"
                                                              : ""
                                                          }`}
                                                        ></span>
                                                      </OverlayTrigger>
                                                    </span>
                                                  </>
                                                ) : (
                                                  <>
                                                    <span className="single-bar">
                                                      {lp.start_level ||
                                                      lp.end_level ||
                                                      lp.is_level ? (
                                                        <Link
                                                          title={
                                                            lp.level_name
                                                              ? lp.level_name
                                                              : ""
                                                          }
                                                          id={"t-single"}
                                                        ></Link>
                                                      ) : (
                                                        ""
                                                      )}
                                                      <OverlayTrigger
                                                        placement="bottom"
                                                        delay={{
                                                          show: 250,
                                                          hide: 400,
                                                        }}
                                                        overlay={
                                                          <Tooltip id="tooltip-disabled">
                                                            {lp.name}
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <span
                                                          className={`dotted-bar inprogress-bar ${
                                                            lp.start_level ||
                                                            lp.end_level ||
                                                            lp.is_level
                                                              ? "startp"
                                                              : ""
                                                          }`}
                                                        ></span>
                                                      </OverlayTrigger>
                                                    </span>
                                                  </>
                                                )}
                                              </>
                                            )
                                          // )
                                        )}
                                    </>
                                  )}
                                </span>
                              )}
                            </div>
                          </td>
                        )}
                        <td>
                          {item?.roles === "Real Estate Agent" ||
                          item?.roles === "Participant"
                            ? "End user"
                            : item?.roles === "Manager"
                            ? "Team Manager"
                            : item?.roles === "External Instructor"
                            ? "External Trainer"
                            : item?.roles}
                        </td>
                        <td>{item?.email}</td>
                        <td>{item?.user_status ? "Active" : "In Active"}</td>
                        <td>{item?.office_name}</td>
                        {/* <td>{item?.user_manager_name}</td> */}
                        {/* <td>{item?.ur_user_status ? 'Active' : 'In Active'}</td> */}
                        <td>
                          {fromPage === 1 || fromPage === 4 ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item?.course_name,
                              }}
                            />
                          ) : (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item?.lp_name,
                              }}
                            />
                          )}
                        </td>

                        <td>{reportType==="learningpath"?item.lp_id:item.course_id}</td>
                        {reportType==="compliance"&&<td>{item.asset_type}</td>}
                        {reportType==="compliance"&&<td>{formatMinutes(item.duration)}</td>}
                        <td>{item.complete_date?moment.unix(item.complete_date).utc().format("DD/MM/YYYY hh:mm A"):"-"}</td>
                        <td
                          className={
                            item?.profile_status === "in-progress" ||
                            item?.profile_status === "Inprogress"
                              ? "inprogress-sta status-rp"
                              : item?.profile_status === "Yet to start" ||
                                item?.profile_status === "not-started"
                              ? "start-sta-nonod status-rp"
                              : item?.profile_status.toLowerCase() === "overdue"
                              ? "overdue-sta status-rp"
                              : "completed-sta status-rp"
                          }
                        >
                          <strong>
                            {item?.profile_status === "in-progress" ||
                            item?.profile_status === "Inprogress" ||
                            item?.profile_status === "inprogress"
                              ? "In Progress"
                              : item?.profile_status === "Yet to start" ||
                                item?.profile_status === "not-started"
                              ? "Yet to start"
                              : item?.profile_status.toLowerCase() === "overdue"
                              ? "Overdue"
                              : "Completed"}
                          </strong>
                        </td>
                        {reportType !== "learningpath" && (
                          <td className="progress-bxo">
                            <div className="d-flex align-items-center justify-content-center rogress">
                              <strong className="d-progress">
                                {item?.profile_progress !== undefined &&
                                item?.profile_progress !== ""
                                  ? item?.profile_progress + "%"
                                  : "-"}
                              </strong>
                              {reportType === "learningpath" ? (
                                !_.isEmpty(item?.lp_details) ? (
                                  <span className="progess-bars-reports">
                                    {item?.lp_details.length > 0 &&
                                      item.lp_details.map(
                                        (lp) =>
                                          // return (
                                          _.isArray(lp) ? (
                                            lp?.length > 0 ? (
                                              <>
                                                <span className="group-dot">
                                                  <Link
                                                    title={lp[0]?.level_name}
                                                    id="t-2"
                                                  ></Link>
                                                  {lp?.length > 0 &&
                                                    lp?.map((lp1) => {
                                                      return (
                                                        console.log("lp1", lp1),
                                                        (
                                                          <>
                                                            {_.toNumber(
                                                              lp1.progress
                                                            ) >= 100 ? (
                                                              <OverlayTrigger
                                                                placement="bottom"
                                                                delay={{
                                                                  show: 250,
                                                                  hide: 400,
                                                                }}
                                                                overlay={
                                                                  <Tooltip id="tooltip-disabled">
                                                                    {lp1.name}
                                                                  </Tooltip>
                                                                }
                                                              >
                                                                <span
                                                                  className={`dotted-bar complete-bar ${
                                                                    lp1.start_level ||
                                                                    lp1.end_level ||
                                                                    lp1.is_level
                                                                      ? "startp"
                                                                      : ""
                                                                  }`}
                                                                ></span>
                                                              </OverlayTrigger>
                                                            ) : _.toNumber(
                                                                lp1.progress
                                                              ) === 0 ||
                                                              lp1.progress ===
                                                                null ? (
                                                              <OverlayTrigger
                                                                placement="bottom"
                                                                delay={{
                                                                  show: 250,
                                                                  hide: 400,
                                                                }}
                                                                overlay={
                                                                  <Tooltip id="tooltip-disabled">
                                                                    {lp1.name}
                                                                  </Tooltip>
                                                                }
                                                              >
                                                                <span
                                                                  className={`dotted-bar ${
                                                                    lp1.start_level ||
                                                                    lp1.end_level ||
                                                                    lp1.is_level
                                                                      ? "startp"
                                                                      : ""
                                                                  }`}
                                                                ></span>
                                                              </OverlayTrigger>
                                                            ) : (
                                                              <OverlayTrigger
                                                                placement="bottom"
                                                                delay={{
                                                                  show: 250,
                                                                  hide: 400,
                                                                }}
                                                                overlay={
                                                                  <Tooltip id="tooltip-disabled">
                                                                    {lp1.name}
                                                                  </Tooltip>
                                                                }
                                                              >
                                                                <span
                                                                  className={`dotted-bar inprogress-bar ${
                                                                    lp1.start_level ||
                                                                    lp1.end_level ||
                                                                    lp1.is_level
                                                                      ? "startp"
                                                                      : ""
                                                                  }`}
                                                                ></span>
                                                              </OverlayTrigger>
                                                            )}
                                                          </>
                                                        )
                                                      );
                                                    })}
                                                </span>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <>
                                              {_.toNumber(lp.progress) >=
                                              100 ? (
                                                <>
                                                  <span className="single-bar">
                                                    {lp.start_level ||
                                                    lp.end_level ||
                                                    lp.is_level ? (
                                                      <Link
                                                        title={
                                                          lp.level_name
                                                            ? lp.level_name
                                                            : ""
                                                        }
                                                        id={"t-single"}
                                                      ></Link>
                                                    ) : (
                                                      ""
                                                    )}

                                                    <OverlayTrigger
                                                      placement="bottom"
                                                      delay={{
                                                        show: 250,
                                                        hide: 400,
                                                      }}
                                                      overlay={
                                                        <Tooltip id="tooltip-disabled">
                                                          {lp.name}
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <span
                                                        className={`dotted-bar complete-bar ${
                                                          lp.start_level ||
                                                          lp.end_level ||
                                                          lp.is_level
                                                            ? "startp"
                                                            : ""
                                                        }`}
                                                      ></span>
                                                    </OverlayTrigger>
                                                  </span>
                                                </>
                                              ) : _.toNumber(lp.progress) ===
                                                  0 || lp.progress === null ? (
                                                <>
                                                  <span className="single-bar">
                                                    {lp.start_level ||
                                                    lp.end_level ||
                                                    lp.is_level ? (
                                                      <Link
                                                        title={
                                                          lp.level_name
                                                            ? lp.level_name
                                                            : ""
                                                        }
                                                        id={"t-single"}
                                                      ></Link>
                                                    ) : (
                                                      ""
                                                    )}
                                                    <OverlayTrigger
                                                      placement="bottom"
                                                      delay={{
                                                        show: 250,
                                                        hide: 400,
                                                      }}
                                                      overlay={
                                                        <Tooltip id="tooltip-disabled">
                                                          {lp.name}
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <span
                                                        className={`dotted-bar ${
                                                          lp.start_level ||
                                                          lp.end_level ||
                                                          lp.is_level
                                                            ? "startp"
                                                            : ""
                                                        }`}
                                                      ></span>
                                                    </OverlayTrigger>
                                                  </span>
                                                </>
                                              ) : (
                                                <>
                                                  <span className="single-bar">
                                                    {lp.start_level ||
                                                    lp.end_level ||
                                                    lp.is_level ? (
                                                      <Link
                                                        title={
                                                          lp.level_name
                                                            ? lp.level_name
                                                            : ""
                                                        }
                                                        id={"t-single"}
                                                      ></Link>
                                                    ) : (
                                                      ""
                                                    )}
                                                    <OverlayTrigger
                                                      placement="bottom"
                                                      delay={{
                                                        show: 250,
                                                        hide: 400,
                                                      }}
                                                      overlay={
                                                        <Tooltip id="tooltip-disabled">
                                                          {lp.name}
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <span
                                                        className={`dotted-bar inprogress-bar ${
                                                          lp.start_level ||
                                                          lp.end_level ||
                                                          lp.is_level
                                                            ? "startp"
                                                            : ""
                                                        }`}
                                                      ></span>
                                                    </OverlayTrigger>
                                                  </span>
                                                </>
                                              )}
                                            </>
                                          )
                                        // )
                                      )}
                                  </span>
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                      // );
                    ))}
                </tbody>
              </table>
            </div>

            {/* PAGINATION COMPONENT */}
            <div className="pagetab d-flex justify-content-center gap-2 mt-3 align-items-center mb-5">
              <div className="input-lear">
                <select
                  className="form-select input_searchfield mb-0 pe-5"
                  disabled={disableFooter}
                  onChange={(evt) => {
                    if (!disableFooter) {
                      setDisableFooter(true);
                      setCurrentPage(1);
                      // if (pageNum === 0) {
                      setPageNum(1);
                      // }
                      setPageSize(_.toNumber(evt.target.value));
                      resetAllSelection();
                    }
                  }}
                >
                  <option selected={pageSize === 20} value="20">
                    20
                  </option>
                  <option selected={pageSize === 50} value="50">
                    50
                  </option>
                  <option selected={pageSize === 100} value="100">
                    100
                  </option>
                </select>
              </div>
              <span className="rosetext">{t("rows per page")}</span>
              <PaginationProgress
                className="pagination-bar m-0"
                disablePagination={disableFooter}
                currentPage={pageNum ? pageNum : 1}
                totalCount={profileReports?.total_records}
                pageSize={pageSize}
                onPageChange={(page) => {
                  console.log("PG NUMBER footer", disableFooter);
                  if (!disableFooter) {
                    setPageNum(page);
                    setDisableFooter(true);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderGraphReport = () => {
    return (
      <ReportGraphSection
        series={series}
        legends={legends}
        isLoading={isLoading}
        type={type}
        isAmount={false}
      />
    );
  };

  return (
    <>
      <section
        className={`table-report-layout mt-rem 
       ${
         reportType === "learningpath"
           ? `class-${reportType}`
           : "class-new-report"
       }`}
      >
        {true ? (
          <div className="container-pwc">
            <div className="row">
              <div className="col-md-12">
                <div className="table-head">{t("Details")}</div>
              </div>

              <div className="d-flex justify-content-between align-items-center col-md-12 search__input mb-4 flex-wrap gap-3">
                <div className="input-lear position-relative d-flex">
                  <label htmlFor="search" className="input__label">
                    {t("Search")}
                  </label>
                  <input
                    type="search"
                    id="search"
                    name="search"
                    className="input_searchfield_search mb-0"
                    autocomplete="off"
                    onChange={(evt) => {
                      // searchTable(evt.target.value);
                      // setSearchInput(evt.target.value);
                      if (searchTerm && !evt.target.value) {
                        setSearchInput("");
                        setPageNum(1);
                      }
                      setSearchTerm(evt.target.value);
                    }}
                    value={searchTerm}
                  />
                  <button
                    className="button-reset"
                    onClick={() => {
                      // searchTable(searchInput);
                      if (searchInput == searchTerm && searchTerm) fetchData();
                      setSearchInput(searchTerm);
                      setPageNum(1);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      id="Find"
                      width="28"
                      height="28"
                      viewBox="0 0 30 30"
                    >
                      <defs>
                        <linearGradient
                          id="linear-gradient"
                          y1="0.5"
                          x2="1"
                          y2="0.5"
                          gradientUnits="objectBoundingBox"
                        >
                          <stop offset="0" stopColor="#415385" />
                          <stop offset="1" stopColor="#415385" />
                        </linearGradient>
                      </defs>
                      <circle
                        id="Ellipse_191"
                        data-name="Ellipse 191"
                        cx="15"
                        cy="15"
                        r="15"
                        fill="url(#linear-gradient)"
                      />
                      <circle
                        id="Ellipse_192"
                        data-name="Ellipse 192"
                        cx="13"
                        cy="13"
                        r="13"
                        transform="translate(2 2)"
                        fill="#fff"
                      />
                      <path
                        id="Icon_awesome-search"
                        data-name="Icon awesome-search"
                        d="M14.372,12.6,11.535,9.762a.683.683,0,0,0-.484-.2h-.464a5.917,5.917,0,1,0-1.025,1.025v.464a.683.683,0,0,0,.2.484L12.6,14.372a.68.68,0,0,0,.965,0l.805-.805A.686.686,0,0,0,14.372,12.6ZM5.92,9.562A3.643,3.643,0,1,1,9.562,5.92,3.641,3.641,0,0,1,5.92,9.562Z"
                        transform="translate(7.715 7.714)"
                        fill="#415385"
                      />
                    </svg>
                  </button>
                </div>

                {false && (
                  <div className="d-flex gap-2 align-items-center">
                    <div className="select-all-option table-responsive1">
                      <div
                        className={`form-check cursor-pointer position-relative p-0 m-0 d-flex align-items-center ${
                          isHaveCompleted ? "opacity-half" : "cursor-pointer"
                        }`}
                        onClick={() => {
                          // if (isAllPageSelectedCheck) {
                          //   resetAllSelection()
                          // } else {
                          //   allPageSelectFunc();
                          // }
                          if (!isHaveCompleted) clickAllSelectedUser();
                        }}
                      >
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          checked={isAllSelected && !isHaveCompleted}
                        />
                        <label
                          className="form-check-label cursor-pointer"
                          for="selectall"
                        ></label>
                      </div>
                      <label className="fromd">{t("Select All")}</label>
                    </div>
                    <div className="input-lear">
                      <button
                        className="btn btn-primary-complete bckbtn m-0"
                        onClick={() => {
                          console.log("selectedUsers: ", selectedRemindUsers);
                          remindSelectedUserReq();
                        }}
                        disabled={!isAnyOneSelected}
                      >
                        {t("Remind Selected Users")}
                      </button>
                    </div>
                  </div>
                )}
              </div>
              {isAllPageSelectedCheck && false ? (
                <div className="col-md-12">
                  <div className="textskected">
                    All <b>{allSelectedCount}</b> Agents are selected.
                  </div>
                </div>
              ) : isAllSelected && !isHaveCompleted ? (
                <div className="col-md-12">
                  <div className="textskected">
                    {t("all")} <b>{selectedRemindUsers?.length}</b>{" "}
                    {t("Participants on this page are selected.")}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            {canShow ? (
              <div className="not-found mt-3">
                <div className=" interboxes">
                  <div className="d-flex w-100 gap-2 align-items-center justify-content-center">
                    {t("Loading Report Data")}
                    <div className="spinner">
                      <div className="bounce1"></div>
                      <div className="bounce2"></div>
                      <div className="bounce3"></div>
                    </div>
                  </div>
                </div>
              </div>
            ) : currentTableData && currentTableData?.length > 0 ? (
              renderTableReport()
            ) : (
              <>
                <div className="not-found mt-3">
                  <div className=" interboxes">
                    <img
                      src="/images/finwell-img/NoSearchResults.svg"
                      alt="Not Found"
                    />
                    <p>{message}</p>
                  </div>
                </div>
              </>
            )}
          </div>
        ) : (
          ""
        )}
      </section>
      <SimplePopup
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        isRightIcon={true}
        isMobile={isMobile}
      />
    </>
  );
};

export default ProgressReportTableComponent;
